import { API_URL } from 'app/config/envVariables';
import { getAccessToken } from 'entities/User';

export const generatePaymentPdfLink = (paymentId: string): string => {
  const token = getAccessToken();

  const paymentPdfLink = `${API_URL}/billing-documents/payments/${paymentId}/pdf?token=${token}`;

  return paymentPdfLink;
};
